import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import CircularProgress from "@mui/material/CircularProgress";
import { getOneAAFF, getSenalizaciones } from "../../../services";
import { toast } from "react-toastify";
import { withRouter } from "../../../providers/withRouter";
import Excel from "../../../icons/excel.svg"

const ExportarComunidadesSinSenalesExcel = ({ nif }) => {
  const { t } = useTranslation(["aaff", "common", "properties", "pdfs"]);
  const [isLoading, setIsLoading] = useState(false);

  const exportar = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const toastId = toast.loading(t("common:excel.generatingExcel"));
    try {
      const aaff = await getOneAAFF(nif);
      const senalizaciones = await getSenalizaciones(aaff.id);

      // Invertimos la estructura: cada señalización trae sus comunidades,
      // pero aquí queremos, por cada comunidad, en cuántas señales aparece.
      const comunidadesMap = new Map();
      senalizaciones?.forEach((senal) => {
        senal.comunidades?.forEach((com) => {
          const key = com.nif || com.id;
          if (comunidadesMap.has(key)) {
            comunidadesMap.get(key).totalSenales += 1;
          } else {
            comunidadesMap.set(key, {
              razonSocial: com.razonSocial,
              nif: com.nif,
              direccion: com.direccion,
              municipio: com.municipio,
              provincia: com.provincia,
              codigoPostal: com.codigoPostal,              
              // totalSenales: 1,
            });
          }
        });
      });

      const comunidades = Array.from(comunidadesMap.values()).sort(
        (a, b) => b.totalSenales - a.totalSenales
      );

      // Si no hay comunidades, no se descarga nada: solo aviso.
      if (comunidades.length === 0) {
        toast.update(toastId, {
          render: t("pdfs:reports.communitiesWithoutSignals.noPendingCommunities"),
          type: "info",
          isLoading: false,
          autoClose: 4000,
        });
        return;
      }

      const rows = comunidades.map((c) => ({
        [t("properties:excel.community")]: c.razonSocial,
        [t("properties:excel.nif")]: c.nif,
        [t("properties:excel.address")]: c.direccion,
        [t("properties:excel.locality")]: c.municipio,
        [t("properties:excel.province")]: c.provincia,
        [t("properties:excel.postalCode")]: c.codigoPostal,
        // [t("properties:excel.signalsCount")]: c.totalSenales,
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet["!cols"] = [{ wpx: 260 }, { wpx: 110 }, { wpx: 240 }, { wpx: 90 }];

      // Cabeceras en negrita
      if (worksheet["!ref"]) {
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });
          if (worksheet[headerCell]) {
            worksheet[headerCell].s = { font: { bold: true } };
          }
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Comunidades");

      const razonSocialLimpia = (aaff?.razonSocial || "")
        .replace(/[\\/:*?"<>|]/g, "-")
        .trim();
      const fileName = `Comunidades sin senales${
        razonSocialLimpia ? " " + razonSocialLimpia : ""
      }.xlsx`;

      XLSX.writeFile(workbook, fileName);

      toast.update(toastId, {
        render: t("common:excel.excelSuccess"),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: t("common:excel.excelError"),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      className="bigBtn"
      onClick={exportar}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40px",
        minWidth: 100,
        cursor: isLoading ? "default" : "pointer",
      }}
    >
      {isLoading ? (
        <CircularProgress style={{ color: "#92004D", width: 18, height: 18 }} />
      ) : (
        <>
          <img src={Excel} alt={t("aaff:details.communitiesWithoutSignals")} width={30} height={30} />
          <span style={{ marginLeft: 5 }}>{t("aaff:details.communitiesWithoutSignals")}</span>
        </>
      )}
    </button>
  );
};

export default withRouter(ExportarComunidadesSinSenalesExcel);
